import React from 'react';
import { Input, MaskedInput } from 'rsuite';

import './styles.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').MaskedInputProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomMaskedInput({ ...rest }) {
  return <MaskedInput {...rest} className="custom-input" />;
}
